import {
  adminClient,
  customSessionClient,
  phoneNumberClient,
} from "better-auth/client/plugins";
import { createAuthClient } from "better-auth/react";
import { config } from "@/shared/lib/config";
import { fetcher } from "@/shared/lib/fetcher";
import type { auth } from "../../domain/contracts/auth";
import type { EmployeeProfileResponseDTO, PatchMeProfileDTO } from "../../domain/contracts/employee-profile";

export const authClient = createAuthClient({
  baseURL: config.authUrl,
  plugins: [
    phoneNumberClient(),
    adminClient(),
    customSessionClient<typeof auth>(),
  ],
});

export const profileApi = {
  async get() {
    return fetcher.get<{
      user: {
        id: string;
        name: string;
        email: string;
        image?: string | null;
        phoneNumber?: string | null;
      };
    }>(`${config.apiUrl}/me`);
  },
  async update(form: FormData) {
    return fetcher.putForm<{ user: { id: string } }>(
      `${config.apiUrl}/me`,
      form,
    );
  },
  async getMyProfile() {
    return fetcher.get<EmployeeProfileResponseDTO>(`${config.apiUrl}/me/profile`);
  },
  async patchMyProfile(dto: PatchMeProfileDTO) {
    return fetcher.patch<{ success: boolean }>(`${config.apiUrl}/me/profile`, dto);
  },
};
